var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.57143C2 3.88944 2.26339 3.23539 2.73223 2.75315C3.20107 2.27092 3.83696 2 4.5 2H24.5C25.163 2 25.7989 2.27092 26.2678 2.75315C26.7366 3.23539 27 3.88944 27 4.57143V17.4286C27 18.1106 26.7366 18.7646 26.2678 19.2468C25.7989 19.7291 25.163 20 24.5 20H4.5C3.83696 20 3.20107 19.7291 2.73223 19.2468C2.26339 18.7646 2 18.1106 2 17.4286V4.57143Z",
    stroke: "none",
    className: "primary-stroke",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.8571C16.5711 14.8571 18.25 13.1302 18.25 11C18.25 8.86972 16.5711 7.14282 14.5 7.14282C12.4289 7.14282 10.75 8.86972 10.75 11C10.75 13.1302 12.4289 14.8571 14.5 14.8571Z",
    stroke: "none",
    className: "primary-stroke",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.14286C3.32608 7.14286 4.59785 6.60102 5.53553 5.63655C6.47322 4.67208 7 3.36397 7 2",
    stroke: "none",
    className: "primary-stroke",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20C22 18.636 22.5268 17.3279 23.4645 16.3634C24.4021 15.399 25.6739 14.8571 27 14.8571",
    stroke: "none",
    className: "primary-stroke",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.1d51493b.svg";
export { ForwardRef as ReactComponent };